code

<template>

  <div class="container">
    <div class="row fh-row justify-content-center">
      <div class="col-md-6 pl-0 pr-0 align-self-center">
        <mdb-card class="z-depth-1 card-height">
          <mdb-card-header color="white">
            <div class="container-fluid">
              <div class="row">
                <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                  <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                  <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                  <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                </div>
              </div>
            </div>
          </mdb-card-header>
          <mdb-card-body class="text-center">
            <form ref="f">
              <div class="container-fluid">
                <div class="row hh-row">
                  <div class="col-12 align-self-center">
                    <span class="mb-4">
                      <div class="swal2-icon swal2-success swal2-animate-success-icon"
                           style="display: flex;"
                           v-if="status === 'Verified'">
                          <div class="swal2-success-circular-line-left"></div>
                          <span class="swal2-success-line-tip"></span>
                          <span class="swal2-success-line-long"></span>
                          <div class="swal2-success-ring"></div>
                          <div class="swal2-success-fix"></div>
                          <div class="swal2-success-circular-line-right"></div>
                      </div>
                      <div
                         v-else-if="status === 'Not Verified'"
                         class="swal2-icon swal2-error swal2-animate-error-icon"
                         style="display: flex;"><span class="swal2-x-mark"><span
                         class="swal2-x-mark-line-left"></span><span
                         class="swal2-x-mark-line-right"></span></span>
                      </div>
                    </span>
                    <span>
                      <h3>{{ info_message }}</h3>
                      <p>{{ message }}</p>
                    </span>
                  </div>
                  <div v-if="accountType" class="col-12 align-self-center">
                    <h5>{{ $t("selectedAccount") }}</h5>
                    <h3><strong>{{ accountType }}</strong></h3>
                  </div>
                </div>
              </div>
            </form>
          </mdb-card-body>
          <mdb-card-footer>
            <div class="col-12 align-self-center">
              <div class="row justify-content-center">
                <div class="col-md-12 mb-1 ">
                  <mdb-btn style="font-size: 15px" block color="primary" class="next-btn" size="md" disabled>
                    <i class="fa-phone fas text-white mr-2" />
                    {{ $t("callHelp") }}
                  </mdb-btn>
                </div>
                <div class="col-md-12 mb-1 ">
                  <mdb-btn style="font-size: 15px" block color="primary" class="next-btn" size="md" @click="navigate">
                    {{ $t("finish") }}
                  </mdb-btn>
                </div>
              </div>
            </div>
          </mdb-card-footer>
        </mdb-card>
      </div>
    </div>
    <div id="overlay" v-if="spinner">
      <div style="position: fixed;top: 50%;left: 45%; width: 10%;" class="text-center text-white">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>

        </div>
        <p>{{ $t("waitMsg") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {i18n} from "../../translations";

export default {
  name: "CompletePage",
  data() {
    return {
      spinner: false,
      info_message: null,
      message: null,
      report: null,
      status: null,
      accountType: null,
      mobileStatus: null,
    };
  },
  async mounted() {
    i18n.locale = this.$store.state.language
    this.spinner = true
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (this.$store.state.session_id != null) {

      let session = await this.$http.get('/sessions/' + this.$store.state.session_id);
      this.status = session.data.status;
      this.report = session.data.report;

      if (this.report) {
        if (this.report.bank_account != null && this.report.bank_account.type != null) {
          this.accountType = this.report.bank_account.type
        }
        if (this.report.mobile_verified != null) {
          this.mobileStatus = this.report.mobile_verified.status
        }
        if ([this.report.id_to_selfie_matching, this.report.nadra_data_match, this.report.information_match,
          this.mobileStatus, this.report.undertaking_accepted, this.report.valid_data_extracted].includes(false)) {
          if (this.report.id_to_selfie_matching === false) {
            this.info_message = this.$t("faceNotMatched")
          } else if (this.report.valid_data_extracted === false) {
            this.info_message = this.$t("dataNotExtracted")
          } else if (this.report.nadra_data_match === false) {
            this.info_message = this.$t("nadraNotMatched")
          } else if (this.report.information_match === false) {
            this.info_message = this.$t("infoNotMatched")
          } else if (this.mobileStatus === false) {
            this.info_message = this.$t("mobileNotMatched")
          } else if (this.report.undertaking_accepted === false) {
            this.info_message = this.$t("undertakingNotAccepted")
          }
        } else if (this.status === 'Verified') {
          this.info_message = this.$t("congrats")
          this.message = this.$t("accountOpened")
        } else {
          this.info_message = "Error"
        }
      }
      this.spinner = false
    }

    this.$localForageService.clear();
    this.$store.commit("setExtractTextState", {
      state: false,
      data: false
    });
    this.$store.commit("setTrustedPartnerState", {
      name: "",
      number: ""
    });
    this.$store.commit("setSessionID", {
      session_id: null,
      agent_name: null
    })
    this.$store.commit('setManualVerification', {
      manual_verification: false
    })
    this.$store.commit('setSelectedAgent', {
      selected_agent: null
    })
  },
  methods: {
    navigate() {
      location.replace('/test')
    }
  }
}
</script>

<style scoped>

</style>
